import { tableColumns, urls, names } from './columns'
const configs = {}
Object.keys(tableColumns).forEach(e => {
  configs[e] = {}
  configs[e].columns = tableColumns[e]
  configs[e].url = urls[e]
  configs[e].filterConfig = []
  configs[e].attrKeys = {
    searchContent: 'codeOrName',
    pageNo: 'pageNo',
    pageSize: 'pageSize',
    value: 'id',
    selectLabel: ['code', 'name'],
    label: ['code', 'name']
  }
  configs[e].title = names[e]
  configs[e].handleData = (data) => {
    return data
  }
})
export default {
  ...configs,
  // 账簿
  default_accountBook: {
    // 请求地址 /finsaas-gls/accountBook/findAccountBookPage
    url: '/finsaas-gls/accountBook/defaultList',
    // table列表展示字段
    columns: [
      {
        title: '编码',
        field: 'code',
        tooltip: true
      }, {
        title: '名称',
        field: 'name',
        tooltip: true
      }, {
        title: '账簿类型',
        field: 'accountBookTypeName',
        tooltip: true
      }, {
        title: '公司',
        field: 'companyName',
        tooltip: true
      }
    ],
    // 搜索条件配置
    filterConfig: [],
    // 关键词
    attrKeys: {
      searchContent: 'codeOrName',
      total: 'total',
      value: 'id',
      // 下拉选择时候显示的字段
      selectLabel: ['code', 'name'],
      // 选择后显示的字段
      label: ['code', 'name']
    },
    title: '核算账簿',
    // 对最终的数据处理函数
    handleData(data) {
      return data
    }
  },
  default_company: {
    url: '/finsaas-fixed-asset/sys-user/get-sys-user-company',
    columns: [
      {
        title: '公司编码',
        field: 'code'
      },
      {
        title: '公司名称',
        field: 'name'
      },
      {
        title: '简称',
        field: 'shortName'
      }
    ],
    // 搜索条件配置
    filterConfig: [],
    // 关键词
    attrKeys: {
      searchContent: 'codeOrName',
      value: 'id',
      // 下拉选择时候显示的字段
      selectLabel: ['code', 'name'],
      // 选择后显示的字段
      label: ['name']
    },
    title: '公司',
    dataName: 'companyVoList'
  }
}
